import { render } from "./SiIntroductionV3.vue?vue&type=template&id=32c1fde6&scoped=true"
import script from "./SiIntroductionV3.vue?vue&type=script&lang=js"
export * from "./SiIntroductionV3.vue?vue&type=script&lang=js"

import "./SiIntroductionV3.vue?vue&type=style&index=0&id=32c1fde6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c1fde6"]])

export default __exports__